import React from "react";
import { Container } from "./styles/main";

export default function Main({children,...props}){
    return <Container {...props}>{children}</Container>
}
